module.exports = __webpack_public_path__ + "img/neck-endo-mesomorph-male.094f3452.svg";